import React, { useState, useEffect } from "react";
import { getAllPayments } from "../services/paymentService";
import { useNavigate } from "react-router-dom";

const Payment = () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [limit] = useState(10); // Items per page
  const [totalPages, setTotalPages] = useState(1);
  const navigate = useNavigate();

  useEffect(() => {
    fetchPayments();
  }, [page]);

  const fetchPayments = async () => {
    try {
      setLoading(true);
      const response = await getAllPayments(page, limit);
      setPayments(response.data);
      setTotalPages(Math.ceil(response.total / limit));
    } catch (error) {
      console.error("Error fetching payments:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mx-auto p-0 mb-16">
      <h2 className="text-2xl font-bold mb-4 text-center md:text-left">
        💰 Payment Management
      </h2>

      {/* Record New Payment Button */}
      <button
        className="w-full md:w-auto bg-green-500 text-white px-4 py-2 rounded-lg mb-4"
        onClick={() => navigate("/customer")}
      >
        ➕ Record Payment
      </button>

      {/* Loading Spinner */}
      {loading && <p className="text-center text-gray-500">Loading payments...</p>}

      {/* No Payments Found */}
      {!loading && payments.length === 0 && (
        <p className="text-center text-gray-600">No payments found.</p>
      )}

      {/* Payments List */}
      {!loading && payments.length > 0 && (
        <div className="grid gap-4 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          {payments.map((payment) => (
            <div key={payment.id} className="bg-white shadow-md rounded-lg p-4 border border-gray-200">
              <h3 className="font-bold text-lg">{payment.customer?.name}</h3>
              <p className="text-gray-600">📅 {new Date(payment.payment_date).toLocaleDateString()}</p>
              <p className="text-green-600 font-bold">💵 ₹{payment.amount_paid}</p>
              <p className={`text-sm font-semibold ${payment.status === "Paid" ? "text-green-500" : "text-red-500"}`}>
                {payment.status}
              </p>
            </div>
          ))}
        </div>
      )}

      {/* Pagination Controls */}
      {totalPages > 1 && (
        <div className="flex justify-center mt-6">
          <button
            className={`px-4 py-2 mx-2 rounded-lg ${page === 1 ? 'bg-gray-300' : 'bg-blue-500 text-white hover:bg-blue-600'}`}
            onClick={() => setPage(page - 1)}
            disabled={page === 1}
          >
            ⬅️ Prev
          </button>
          <span className="px-4 py-2 text-lg font-semibold">Page {page} of {totalPages}</span>
          <button
            className={`px-4 py-2 mx-2 rounded-lg ${page === totalPages ? 'bg-gray-300' : 'bg-blue-500 text-white hover:bg-blue-600'}`}
            onClick={() => setPage(page + 1)}
            disabled={page === totalPages}
          >
            Next ➡️
          </button>
        </div>
      )}
    </div>
  );
};

export default Payment;
